import { memo } from 'react'

import { getFrontBack } from '~/boundedContext/cards/components/shuffled-cards/utils'
import { SnoozeCountBadge } from '~/boundedContext/cards/components/snooze-count-badge'
import { useFadingCardStore } from '~/stores/fading-card'
import { useSettingsStore } from '~/stores/settings'

import { DraggableFlipCard } from './draggable-flip-card'

export const FadingFlipCard = memo(() => {
  const fadingCard = useFadingCardStore(state => state.fadingCard)
  const clearFadingCard = useFadingCardStore(state => state.clearFadingCard)
  const cardsFront = useSettingsStore(state => state.cardsFront)

  if (!fadingCard) return null

  return (
    <div className="pointer-events-none absolute inset-x-0 top-0 z-20 h-full">
      <DraggableFlipCard
        examples={fadingCard.examples}
        exitDelta={{ x: fadingCard.deltaX, y: fadingCard.deltaY, rotate: fadingCard.rotate, scale: fadingCard.scale }}
        id={fadingCard.id}
        innerContainerClassName="shadow-lg"
        interactive={false}
        onFadingEnd={clearFadingCard}
        pronunciation={fadingCard.pronunciation}
        {...getFrontBack(fadingCard, cardsFront)}
      >
        <SnoozeCountBadge card={fadingCard} className="pointer-events-none absolute right-2 top-2 z-10" />
      </DraggableFlipCard>
    </div>
  )
})

FadingFlipCard.displayName = 'FadingFlipCard'
